import React from 'react'
import { Sparkles } from 'lucide-react'

// TrialBanner (FE2) — the teal "preview expires on …" banner shown while an account is in its
// 14-day trial. The expiry date arrives pre-formatted from the backend (an ISO string we only
// localise for display — no client-side date math, no money). Rendered only when in trial.

export default function TrialBanner({ expiresAtIso }: { expiresAtIso: string | null }) {
  const formatted = expiresAtIso
    ? new Date(expiresAtIso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
    : null

  return (
    <div className="flex items-start gap-3 rounded-xl border border-teal-200 bg-teal-50 p-4 shadow-sm">
      <Sparkles className="mt-0.5 h-5 w-5 shrink-0 text-teal-600" />
      <div className="text-sm">
        <p className="font-semibold text-teal-800">You’re on a free preview</p>
        <p className="mt-0.5 text-teal-700">
          {formatted ? (
            <>
              Your preview ends on{' '}
              <span className="font-semibold tabular-nums">{formatted}</span>. Add a card to keep publishing rates after it
              expires.
            </>
          ) : (
            <>Add a card to keep publishing rates once your preview ends.</>
          )}
        </p>
      </div>
    </div>
  )
}
